import styled, { css } from "styled-components";
import { lighten, readableColor } from 'polished';
import { TdProps } from ".";

export const Td = styled.td<TdProps>`
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
  font-size: 15px;
  text-align: ${props => props.align}
`;